import React, {useEffect, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import { KTSVG } from '../../../../../_metronic/helpers'

type Props = {
  showModal: boolean
  handleCloseModal: () => void
  urlDoc: string
  title: string
}

const ModalImagen: React.FC<Props> = ({showModal, handleCloseModal, urlDoc, title}) => {
  const fileName = urlDoc.substring(urlDoc.lastIndexOf('/') + 1)

  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      centered
      backdrop='static'
      dialogClassName='modal-dialog modal-dialog-centered mw-750px'
    >
      <Modal.Body className='p-1'>
        <div className='modal-header border-0 pb-0 justify-content-end  p-0 mt-0'>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary '
            data-bs-dismiss='modal'
            onClick={handleCloseModal}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
          </div>
        </div>

        <div className='mx-8 mb-5'>
          <div className='px-7 '>
            <div className='fs-5 text-dark fw-bolder text-center'>
              <span className='text-gray-800 fs-4 fw-bolder me-1'>{title}</span>
            </div>
          </div>
          <div className='separator border-gray-200 mb-3'></div>

          <div style={{maxHeight: '450px', overflowY: 'auto'}}>
            <img src={urlDoc} alt={title} style={{width: '100%', height: 'auto'}} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalImagen
